import { Link } from "react-router-dom";
import {
  ShieldCheck,
  Package,
  Sparkles,
  Boxes,
  Tag,
  Truck,
  Clock,
  MapPin,
  Shirt,
  PackagePlus,
  Shield,
  Layers,
  Scissors,
  Newspaper,
  ArrowRight,
} from "lucide-react";
import BigDemenageurCTA from "@/components/BigDemenageurCTA";

const Sections = ({ city }) => (
  <>
    {/* ======= SECTION 2 — Livraison à domicile ======= */}
    <section className="py-14 md:py-20 bg-[#EEF3F7] border-y border-[#cfdbe6]">
      <div className="container-cdm">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-7">
            <div className="overline" style={{ color: "#237cb5" }}>
              Livraison à domicile
            </div>
            <h2 className="mt-3 font-display font-extrabold text-[26px] sm:text-[30px] md:text-[36px] text-[#0f1d2b]">
              Service de livraison de cartons à domicile {city.aCity}
            </h2>
            <p className="mt-5 text-[15px] md:text-base text-[#3a4856] leading-relaxed">
              Parce que charger des piles de cartons encombrants dans
              votre véhicule est une perte de temps inutile, notre
              service logistique gère tout de A à Z, du clic de
              validation à la remise en main propre.
            </p>
          </div>

          <div className="lg:col-span-5 space-y-4">
            {[
              {
                title: "Livraison chez vous",
                body: "Nous acheminons l'intégralité de vos commandes directement sur le pas de votre porte à Morainvilliers, mais également à Orgeval, Villennes-sur-Seine, Médan, Ecquevilly et Vernouillet.",
                Icon: MapPin,
              },
              {
                title: "Respect des horaires",
                body: "Pas de journée perdue à attendre. Nous fixons ensemble un créneau horaire précis et rigoureusement respecté selon vos disponibilités.",
                Icon: Clock,
              },
              {
                title: "Matériel impeccable",
                body: "Vos fournitures vous sont remises à plat, parfaitement propres et totalement sèches, prêtes à être utilisées immédiatement.",
                Icon: ShieldCheck,
              },
            ].map(({ title, body, Icon }) => (
              <div
                key={title}
                className="flex items-start gap-4 bg-white border border-[#cfdbe6] rounded-2xl p-5 md:p-6"
              >
                <span className="flex items-center justify-center shrink-0 h-11 w-11 rounded-full bg-[#237cb5] text-white">
                  <Icon className="h-5 w-5" strokeWidth={2.4} />
                </span>
                <div>
                  <h3 className="font-display font-extrabold text-[15.5px] text-[#0f1d2b] leading-tight">
                    {title}
                  </h3>
                  <p className="mt-2 text-[14px] text-[#3a4856] leading-relaxed">
                    {body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* ======= SECTION 3 — Zoom Dressing ======= */}
    <section className="py-14 md:py-20 bg-white">
      <div className="container-cdm">
        <div className="max-w-3xl">
          <div className="overline" style={{ color: "#237cb5" }}>
            Zoom dressing
          </div>
          <h2 className="mt-3 font-display font-extrabold text-[26px] sm:text-[30px] md:text-[36px] text-[#0f1d2b]">
            Zoom Dressing : transférez vos vêtements sans aucun pli
          </h2>
          <p className="mt-5 text-[15px] md:text-base text-[#3a4856] leading-relaxed">
            Les garde-robes des habitations {city.aCity} contiennent
            souvent des pièces délicates (costumes, robes, manteaux)
            qu&apos;il est fastidieux de décrocher, plier, puis
            repasser à l&apos;arrivée.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-5">
          {/* Carton penderie */}
          <div className="bg-[#EEF3F7] border border-[#cfdbe6] rounded-2xl p-6 md:p-7">
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center h-11 w-11 rounded-full bg-[#237cb5] text-white">
                <Shirt className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <h3 className="font-display font-extrabold text-[18px] text-[#0f1d2b] leading-tight">
                Le Carton Penderie vertical
              </h3>
            </div>
            <p className="mt-4 text-[14.5px] text-[#3a4856] leading-relaxed">
              C&apos;est la solution ultime pour vos vêtements sur
              cintres. Ce carton spécifique de grande hauteur est équipé
              d&apos;une tringle métallique amovible. Vous passez vos
              vêtements directement de votre armoire au carton penderie
              en quelques secondes.
            </p>
            <p className="mt-3 text-[14.5px] text-[#3a4856] leading-relaxed">
              Vos habits restent suspendus, ne se froissent pas et sont
              protégés de la poussière pendant le trajet. À
              l&apos;arrivée {city.aCity}, vous replacez la garde-robe
              directement dans votre nouveau dressing sans la moindre
              séance de repassage.
            </p>
            <div className="mt-5 space-y-2 text-[13px] text-[#3a4856]">
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Tringle métallique amovible
              </div>
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Transfert direct armoire → dressing
              </div>
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Zéro repassage à l&apos;arrivée
              </div>
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Protection anti-poussière
              </div>
            </div>
          </div>

          {/* Housses literie */}
          <div className="bg-[#EEF3F7] border border-[#cfdbe6] rounded-2xl p-6 md:p-7">
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center h-11 w-11 rounded-full bg-[#237cb5] text-white">
                <Shield className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <h3 className="font-display font-extrabold text-[18px] text-[#0f1d2b] leading-tight">
                Les Housses pour matelas et literie
              </h3>
            </div>
            <p className="mt-4 text-[14.5px] text-[#3a4856] leading-relaxed">
              Ne laissez pas vos matelas et couettes à nu dans le
              camion. Utilisez nos housses en polyéthylène épais pour
              les protéger des frottements et des salissures lors des
              manipulations dans les escaliers ou les couloirs.
            </p>
            <p className="mt-3 text-[14.5px] text-[#3a4856] leading-relaxed">
              Ces housses forment également un rempart contre
              l&apos;humidité résiduelle d&apos;un garde-meubles ou
              d&apos;une journée pluvieuse — un détail crucial pour
              préserver l&apos;hygiène et la durée de vie de votre
              literie.
            </p>
            <div className="mt-5 space-y-2 text-[13px] text-[#3a4856]">
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Polyéthylène épais imperméable
              </div>
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Housses matelas, couettes &amp; literie
              </div>
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Protection anti-frottement
              </div>
              <div className="flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#237cb5]" strokeWidth={2.6} />
                Barrière anti-humidité
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/cartons-demenagement"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-[#237cb5] hover:bg-[#1f6da0] text-white font-bold text-[14px] transition-colors"
            data-testid="city-morainvilliers-cta-shop"
          >
            <Boxes className="h-4 w-4" strokeWidth={2.6} />
            Voir les cartons penderies
            <ArrowRight className="h-4 w-4" strokeWidth={2.6} />
          </Link>
          <Link
            to="/fermeture-accessoires"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-white border border-[#cfdbe6] hover:border-[#237cb5] hover:text-[#237cb5] text-[#0f1d2b] font-bold text-[14px] transition-colors"
            data-testid="city-morainvilliers-cta-accessoires"
          >
            <Tag className="h-4 w-4" strokeWidth={2.6} />
            Voir les housses &amp; protections
          </Link>
        </div>
      </div>
    </section>

    {/* ======= CTA Big Déménagement (au milieu) ======= */}
    <section className="py-12 bg-[#EEF3F7] border-y border-[#cfdbe6]">
      <div className="container-cdm">
        <BigDemenageurCTA testId={`city-${city.slug}-bigdem-cta-middle`} />
      </div>
    </section>

    {/* ======= SECTION 4 — Check-List des fournitures ======= */}
    <section className="py-14 md:py-20 bg-white">
      <div className="container-cdm">
        <div className="max-w-3xl">
          <div className="overline" style={{ color: "#237cb5" }}>
            La check-list
          </div>
          <h2 className="mt-3 font-display font-extrabold text-[26px] sm:text-[30px] md:text-[36px] text-[#0f1d2b]">
            La Check-List des fournitures : ne tombez pas en panne le
            jour J
          </h2>
          <p className="mt-5 text-[15px] md:text-base text-[#3a4856] leading-relaxed">
            Rien n&apos;est plus frustrant que de devoir stopper ses
            préparatifs un dimanche soir à cause d&apos;un manque de
            matériel. Voici les indispensables à prévoir en quantité
            suffisante.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {[
            {
              title: "Le ruban adhésif technique",
              body: "Comptez en moyenne un rouleau d'adhésif professionnel pour 15 à 20 cartons. Privilégiez notre adhésif à forte adhérence pour éviter que les fonds de cartons ne s'ouvrent sous le poids.",
              Icon: Scissors,
            },
            {
              title: "Le film à bulles d'air",
              body: "Prévoyez au moins un large rouleau pour envelopper vos bibelots, cadres, miroirs et écrans. Chaque objet fragile doit avoir sa propre couche protectrice.",
              Icon: PackagePlus,
            },
            {
              title: "Le papier journal vierge ou kraft",
              body: "Idéal pour froisser et combler les espaces vides à l'intérieur de vos cartons de vaisselle afin d'éviter que les objets ne s'entrechoquent.",
              Icon: Newspaper,
            },
          ].map(({ title, body, Icon }) => (
            <div
              key={title}
              className="flex items-start gap-4 bg-[#EEF3F7] border border-[#cfdbe6] rounded-2xl p-5 md:p-6"
            >
              <span className="flex items-center justify-center shrink-0 h-11 w-11 rounded-full bg-[#237cb5] text-white">
                <Icon className="h-5 w-5" strokeWidth={2.4} />
              </span>
              <div>
                <h3 className="font-display font-extrabold text-[15.5px] text-[#0f1d2b] leading-tight">
                  {title}
                </h3>
                <p className="mt-2 text-[14px] text-[#3a4856] leading-relaxed">
                  {body}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/fermeture-accessoires"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-[#237cb5] hover:bg-[#1f6da0] text-white font-bold text-[14px] transition-colors"
            data-testid="city-morainvilliers-cta-fermeture"
          >
            <Layers className="h-4 w-4" strokeWidth={2.6} />
            Adhésifs, film &amp; papier kraft
            <ArrowRight className="h-4 w-4" strokeWidth={2.6} />
          </Link>
          <Link
            to="/livraison"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-white border border-[#cfdbe6] hover:border-[#237cb5] hover:text-[#237cb5] text-[#0f1d2b] font-bold text-[14px] transition-colors"
            data-testid="city-morainvilliers-cta-livraison"
          >
            <Truck className="h-4 w-4" strokeWidth={2.6} />
            Nos modalités de livraison
          </Link>
        </div>
      </div>
    </section>

    {/* ======= SECTION 5 — CTA retour département ======= */}
    <section className="py-10 md:py-14 bg-[#EEF3F7] border-t border-[#cfdbe6]">
      <div className="container-cdm">
        <Link
          to={`/cartons-demenagement/${city.deptSlug}`}
          className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-white border border-[#cfdbe6] hover:border-[#237cb5] hover:text-[#237cb5] text-[#0f1d2b] font-bold text-[14px] transition-colors"
          data-testid="city-morainvilliers-cta-back-dept"
        >
          <Package className="h-4 w-4" strokeWidth={2.6} />
          Voir la page {city.deptName} ({city.deptCode})
        </Link>
      </div>
    </section>
  </>
);

export default { Sections };
